export function toArabicNumerals(number) {
    const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return String(number).replace(/\d/g, (d) => arabicDigits[d]);
  }
  